// View / edit Applicant slideover. Opened via the window event
// "open-applicant-slideover" { id }. Fetches /applicants/:id.json, lets the
// agent edit requirements (PATCH) and unsubscribe the applicant.
export function applicantSlideover() {
  return {
    open: false,
    loading: false,
    saving: false,
    error: null,
    saveError: null,
    applicant: null,
    applicantId: null,
    zIndex: 100010,
    agencyAreas: [],
    areaOpen: false,
    form: {},

    init() {
      try {
        this.agencyAreas = JSON.parse(this.$el.dataset.agencyAreas || "[]");
      } catch (e) {
        this.agencyAreas = [];
      }
    },

    openForApplicant(id) {
      const store = Alpine.store?.("slideovers");
      if (store?.getNextZIndex) this.zIndex = store.getNextZIndex();
      if (store?.register) store.register("applicant", id, this);

      this.applicantId = id;
      this.applicant = null;
      this.error = null;
      this.saveError = null;
      this.areaOpen = false;
      this.open = true;
      this.fetchApplicant();
    },

    close() {
      const store = Alpine.store?.("slideovers");
      if (store?.unregister && this.applicantId) store.unregister("applicant", this.applicantId);
      this.open = false;
    },

    async fetchApplicant() {
      if (!this.applicantId) return;
      this.loading = true;
      this.error = null;
      try {
        const response = await fetch(`/applicants/${this.applicantId}.json`, {
          headers: { Accept: "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content },
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        this.applicant = await response.json();
        this.form = {
          min_beds: this.applicant.min_beds,
          max_beds: this.applicant.max_beds,
          max_rent: this.applicant.max_rent,
          furnished: this.applicant.furnished || "",
          needs_parking: this.applicant.needs_parking,
          needs_outside_space: this.applicant.needs_outside_space,
          area_ids: [...(this.applicant.area_ids || [])],
        };
      } catch (e) {
        console.error("Failed to load applicant:", e);
        this.error = "Failed to load the applicant. Please try again.";
      } finally {
        this.loading = false;
      }
    },

    statusLabel(status) {
      return { active: "Active", unconfirmed: "Pending confirmation", expired: "Expired", unsubscribed: "Unsubscribed" }[status] || status;
    },

    // --- Areas multi-select (shared markup contract) ---
    toggleArea(id) {
      id = Number(id);
      const i = this.form.area_ids.indexOf(id);
      if (i === -1) this.form.area_ids.push(id);
      else this.form.area_ids.splice(i, 1);
    },
    isAreaSelected(id) {
      return this.form.area_ids.includes(Number(id));
    },
    areaName(id) {
      const a = this.agencyAreas.find((x) => x.id === Number(id));
      return a ? a.name : "";
    },

    async save() {
      if (this.saving) return;
      this.saving = true;
      this.saveError = null;
      try {
        const response = await fetch(`/applicants/${this.applicantId}`, {
          method: "PATCH",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          },
          body: JSON.stringify({ applicant: this.form }),
        });
        const data = await response.json();
        if (response.ok) {
          this.applicant = data;
          window.dispatchEvent(new CustomEvent("applicant-updated", { detail: { id: this.applicantId, data } }));
          this.close();
        } else {
          this.saveError = (data.errors || ["Could not save."]).join(", ");
        }
      } catch (e) {
        this.saveError = "An unexpected error occurred. Please try again.";
      } finally {
        this.saving = false;
      }
    },

    async unsubscribe() {
      if (!confirm("Unsubscribe this applicant? They'll stop being matched to new properties.")) return;
      try {
        const response = await fetch(`/applicants/${this.applicantId}/unsubscribe`, {
          method: "PATCH",
          headers: { Accept: "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content },
        });
        const data = await response.json();
        if (response.ok) {
          this.applicant = data;
          window.dispatchEvent(new CustomEvent("applicant-updated", { detail: { id: this.applicantId, data } }));
        }
      } catch (e) {
        console.error("Unsubscribe failed:", e);
      }
    },
  };
}
